import Reveal from '@/components/base/Reveal';
import SectionTitle from '@/components/feature/SectionTitle';
import HotRanking from '@/pages/home/components/HotRanking';
import NewsFeed from '@/pages/home/components/NewsFeed';

type FeedSectionProps = {
  query: string;
  activeCategory: string;
  onClearCategory: () => void;
  onClearQuery: () => void;
};

export default function FeedSection({ query, activeCategory, onClearCategory, onClearQuery }: FeedSectionProps) {
  return (
    <section id="feed" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <Reveal>
          <SectionTitle
            kicker="Live Feed"
            title="黑料列表 · 条目速览与热度并行"
            desc="标题优先、摘要精简，短讯与热度值同屏呈现；左侧按更新顺序密集排布，右侧榜单同步刷新。"
            action={{ label: '跳到榜单', href: '#ranking' }}
          />
        </Reveal>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_360px]">
          <Reveal className="min-w-0">
            <NewsFeed
              query={query}
              activeCategory={activeCategory}
              onClearCategory={onClearCategory}
              onClearQuery={onClearQuery}
            />
          </Reveal>
          <Reveal delay={120} className="min-w-0">
            <HotRanking />
          </Reveal>
        </div>
      </div>
    </section>
  );
}